import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { pick, omit, pickBy } from 'lodash-es'
import { getTitle, getSummaryValue, makeFooter, makeModelTable, makeFactorTable } from '../utils'

const SUMMARY_FOOTER_PARAMETER_KEYS = ['molecularWeight', 'henrysLawConstant']

const summaryMapper = (item, meta) => {
  const formatHours = (hours, columnId) => {
    if (typeof hours !== 'number') return '-'

    if (columnId === 'minutes') return hours * 60
    if (columnId === 'days') return hours / 24
    if (columnId === 'years') return hours / (24 * 365)

    return hours
  }

  const buildHalfLifeSummaryValues = (item, meta) =>
    (meta?.children ?? []).map((child) =>
      getSummaryValue({ value: item?.[child?.id], unit: meta?.unit }, `${child.name} Half-life`),
    )

  const buildHalfLifeTableRows = (meta?.children ?? []).map((child) =>
    ['', 'minutes', 'hours', 'days', 'years'].reduce((acc, columnId) => {
      if (columnId === '') return { ...acc, [columnId]: child?.name }

      return { ...acc, [columnId]: formatHours(item?.[child?.id], columnId) }
    }, {}),
  )

  const summaryTable = makeFactorTable(buildHalfLifeTableRows)
  const footer = makeFooter(pick(item?.parameters, SUMMARY_FOOTER_PARAMETER_KEYS))

  return {
    values: buildHalfLifeSummaryValues(item, meta),
    tables: [
      {
        ...(summaryTable ? summaryTable : {}),
        ...(footer.length ? { footer } : {}),
      },
    ],
  }
}

const modelMapper = (item) => {
  const parametersToShow = omit(item?.parameters, SUMMARY_FOOTER_PARAMETER_KEYS)

  const riverParameters = pickBy(parametersToShow, (value, key) => key.startsWith('river'))
  const lakeParameters = pickBy(parametersToShow, (value, key) => key.startsWith('lake'))

  const riverTable = makeModelTable(riverParameters, 'River Properties')
  const lakeTable = makeModelTable(lakeParameters, 'Lake Properties')

  return {
    tables: [riverTable, lakeTable],
  }
}

const wvolWin = (items) => {
  const item = items?.find((candidate) => candidate?.property === 'waterVolatilization')
  const meta = findEpiSuiteGroupById('waterVolatilization')

  return {
    title: getTitle(meta),
    description: 'Half-life from Model River and Lake',
    helpPage: meta?.helpPage,
    summary: summaryMapper(item, meta),
    model: modelMapper(item),
    modelOutput: null,
  }
}

export { wvolWin }
